import AbstractReporter from './AbstractReporter';
import log from 'loglevel';

/**
 * 点播上报code码
 * http://wiki.vhallops.com/pages/viewpage.action?pageId=310543311
 */
const VOD_CODE = {
  Start: 92001,
  Pause: 92002, // 暂停
  Resume: 92004, // 恢复播放
  Info: 92005, // 心跳信息包
  Lag: 94001, /// ** 卡顿 */？？？
  TouchPlay: 92009, // 开始播放
  Destory: 92006 // 销毁播放器实例
};

/**
 * 点播日志上报
 *
 * @export
 * @class VodReporter
 * @extends {AbstractReporter}
 */
export default class VodReporter extends AbstractReporter {
  constructor() {
    super();
    this.isPaused = false;
  }

  __ready() {
    super.__ready();
    this.__sendLog(VOD_CODE.Start, {
      errcode: '2001'
    });
  }

  __touchPlay() {
    super.__touchPlay();
    this.__sendLog(VOD_CODE.TouchPlay, {
      errcode: '2006'
    });
  }

  __lag(e) {
    super.__lag(e);
  }

  __lagRecover(e) {
    super.__lagRecover(e);
  }

  __play(e) {
    super.__play(e);
    // if (this.isPaused) {
    //   this.isPaused = false;
    //   this.__sendLog(VOD_CODE.Resume, {
    //     errcode: '2004'
    //   });
    // } else {
    //   log.debug('正常点击播放--不进行恢复播放的上报！');
    // }
  }

  __pause(e) {
    // this.isPaused = true;
    // this.__sendLog(VOD_CODE.Pause, {
    //   errcode: '2002'
    // });
    super.__pause(e);
  }

  /**
   *  @description 播放结束 - 手动触发一次。心跳包上报。
   */
  __ended() {
    this.infoPack();
    super.__ended();
    super.stop();
  }

  __error(e) {
    super.__error(e);
  }

  infoPack() {
    // 数据修复，避免出现29998、59999之类的数据
    let duration = this._playInfoDuration / 1000;
    this._playInfoDuration = Math.round(duration) * 1000;
    // 屏蔽由于部分手机计时器不准确，导致出现播放时长超过心跳时长的情况
    this._playInfoDuration =
      this._playInfoDuration > this._infoPackIntervalMs ? this._infoPackIntervalMs : this._playInfoDuration;

    const obj = {
      errcode: '2005',
      bc: this._lagCount,
      bt: this._bt,
      tt: this._playInfoDuration,
      tf: this.httpDownloadSize + this.p2pDownloadSize
    };
    log.info('信息包内容：', JSON.stringify(obj));
    this.__sendLog(VOD_CODE.Info, obj);

    super.infoPack();
  }

  destroy() {
    this.__sendLog(VOD_CODE.Destory, {
      errcode: '2006'
    });
    super.destroy();
  }
}
